import {
  LOGIN_BUTTON_REQUEST,
  LOGIN_BUTTON_SUCCESS,
  LOGIN_BUTTON_ERROR,
  PHONE_NUMBER_REQUEST,
  RESET_LOGIN_VALUE,
  DO_LOGIN,
  DO_LOGIN_SUCCESS,
  DO_LOGIN_ERROR,
  GET_REFERRAL_CODE,
  IS_REFERAL_MODAL,
  GET_REFERRAL_CODE_SUCCESS,
  GET_REFERRAL_CODE_ERROR,
  CHECK_MOBILE_FIELD_FOCUS,
  GET_USER_STATUS_REQUEST,
  GET_USER_STATUS_REQUEST_SUCCESS,
  GET_USER_STATUS_REQUEST_ERROR,
  GET_LDC_REQUEST,
  GET_LDC_SUCCESS,
  GET_LDC_ERROR,
  CONFIRM_OTP_REQUEST,
  CONFIRM_OTP_SUCCESS,
  CONFIRM_OTP_ERROR,
  CHECK_KYC_STATUS,
  HANDLE_CHECKBOX,
  GET_PORTFOLIO_REQ,
  GET_PORTFOLIO_ERROR,
  GET_PORTFOLIO_SUCCESS,
  GET_CUSTOMER_DETAILS,
  GET_CUSTOMER_DETAILS_SUCCESS,
  GET_CUSTOMER_DETAILS_ERROR
} from "../../actionType";

const initialState = {
  phone: "",
  isLoading: false,
  status: false,
  loginLoader: false,
  verifyingLoader: false,
  otp: null,
  loginError: null,
  error: null,
  loginStatus: false,
  referralCode: null,
  referalModal: false,
  referralData: null,
  referralError: null,
  isFocus: false,
  userInfo: null,
  userInfoError: null,
  ldcOTPResponse: null,
  ldcOTPError: null,
  confirmOTPError: null,
  confirmOTPResponse: null,
  ckycData: null,
  checkBoxValue: true,
  portFolioData: null,
  errorPortFolio: null,
  loginData: null,
  customerData: null,
  customerDataError: null,
  pageNumber: null
};

const loginReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case PHONE_NUMBER_REQUEST:
      return {
        ...state,
        phone: action.value,
      };

    case LOGIN_BUTTON_REQUEST:
      return {
        ...state,
        status: false,
        isLoading: true,
        error: null,
      };
    case LOGIN_BUTTON_SUCCESS:
      return {
        ...state,
        status: action.status,
        isLoading: false,
        error: null,
      };
    case LOGIN_BUTTON_ERROR:
      return {
        ...state,
        isLoading: false,
        status: false,
        error: action.error,
      };
    case RESET_LOGIN_VALUE:
      return {
        ...state,
        isLoading: false,
        status: false,
        error: null,
        loginLoader: false,
        loginError: null,
        loginStatus: false,
      };
    case DO_LOGIN:
      return {
        ...state,
        loginLoader: true,
        otp: action.loginDetails.otp,
        loginError: null,
        loginStatus: false,
      };
    case DO_LOGIN_SUCCESS:
      return {
        ...state,
        loginLoader: false,
        otp: null,
        loginError: null,
        loginStatus: true,
        loginData: action.data
      };
    case DO_LOGIN_ERROR:
      return {
        ...state,
        loginLoader: false,
        otp: null,
        loginError: action.error,
        loginStatus: false,
      };
    case GET_REFERRAL_CODE:
      return {
        ...state,
        referralCode: action.referralCode,
      };
    case IS_REFERAL_MODAL:
      return {
        ...state,
        referalModal: !state.referalModal,
      };

    case GET_REFERRAL_CODE_SUCCESS:
      return {
        ...state,
        referralData: action.data,
      };
    case GET_REFERRAL_CODE_ERROR:
      return {
        ...state,
        referralError: action.error,
      };
    case CHECK_MOBILE_FIELD_FOCUS:
      return {
        ...state,
        isFocus: action.isFocus,
      };
    case GET_USER_STATUS_REQUEST:
      return {
        ...state,
      };
    case GET_USER_STATUS_REQUEST_SUCCESS:
      return {
        ...state,
        userInfo: action.data,
      };
    case GET_USER_STATUS_REQUEST_ERROR:
      return {
        ...state,
        userInfoError: action.error,
      };
    case GET_LDC_REQUEST:
      return {
        ...state,
      };
    case GET_LDC_SUCCESS:
      return {
        ...state,
        ldcOTPResponse: action.data,
      };
    case GET_LDC_ERROR:
      return {
        ...state,
        ldcOTPError: action.error,
      };
    case CONFIRM_OTP_REQUEST:
      return {
        ...state,
        verifyingLoader: true,
      };
    case CONFIRM_OTP_SUCCESS:
      return {
        ...state,
        confirmOTPResponse: action.data,
      };
    case CONFIRM_OTP_ERROR:
      return {
        ...state,
        confirmOTPError: action.error,
      };
    case CHECK_KYC_STATUS:
      return {
        ...state,
        ckycData: action.data,
      };
    case HANDLE_CHECKBOX:
      return {
        ...state,
        checkBoxValue: action.data,
      };
    case GET_PORTFOLIO_REQ:
      return {
        ...state,
      };
    case GET_PORTFOLIO_ERROR:
      return {
        ...state,
        errorPortFolio: action.error,
      };
    case GET_PORTFOLIO_SUCCESS:
      return {
        ...state,
        portFolioData: action.data,
      };
    case GET_CUSTOMER_DETAILS:
      return {
        ...state,
        pageNumber : action.pageNumber
      };
      case GET_CUSTOMER_DETAILS_SUCCESS:
      return {
        ...state,
        customerData: action.data,
      };
      case GET_CUSTOMER_DETAILS_ERROR:
      return {
        ...state,
        customerDataError: action.error,
      };
    default:
      return state;
  }
};

export default loginReducer;